// Samenwerkingsverbanden (the organisation's own word): the explorer ("where
// the work flows", /org/collabs; areas/collab/explorer), the list
// (/org/collabs/list), a collab's tabs (People · Budget · Plan · Report, one
// page: CollabDetailPage) and Settings > quarters. In the app shell
// (OrgShell). A bare /org/collabs opens the list when that was the person's
// last choice (Explorer · List, remembered per browser). The plan page that
// edits and prints a collab's OGSM is areas/ogsm's CollabOgsmPage, reached
// from the Plan tab at /plan/edit. My quarter, To confirm and Workload are in
// areas/tasks and areas/insight.
import { extra, moved, page, type AreaRoute } from "../../routes/types";

const detailPage = page(() => import("./pages/CollabDetailPage"), "CollabDetailPage");

export const routes: AreaRoute[] = [
  extra("/org/collabs", page(() => import("./explorer/ExplorerPage"), "ExplorerPage")),
  extra("/org/collabs/list", page(() => import("./pages/CollabListPage"), "CollabListPage")),
  extra("/org/collabs/:collabId", detailPage),
  extra("/org/collabs/:collabId/people", detailPage),
  extra("/org/collabs/:collabId/budget", detailPage),
  extra("/org/collabs/:collabId/plan", detailPage),
  extra("/org/collabs/:collabId/report", detailPage),
  extra("/org/collabs/:collabId/plan/edit", page(() => import("../ogsm/pages/CollabOgsmPage"), "CollabOgsmPage")),
  extra("/org/settings/quarters", page(() => import("./pages/CollabSettingsPage"), "CollabSettingsPage")),
  moved("/org/collabs/:collabId/ogsm", "/org/collabs/:collabId/plan"),
  moved("/org/settings/collabs", "/org/settings/quarters"),
];
